var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-alert',{attrs:{"show":_vm.alertShow,"variant":"danger"}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.message)}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }